module.exports = __webpack_public_path__ + "img/arrow-left-icon.6d776db4.svg";